import redPacketBg from "../ui/assets/images/coin-bg.png"
import liubangSkinBg from "../ui/assets/images/skin-bg.png"
import bottomBg from "../ui/assets/images/dj-bg.png"
import topLeftBg from "../ui/assets/images/wz-logo-bg.png"
import shareBizIcon from "../ui/assets/images/logo02.png"
import recordBg from "../ui/assets/images/record-yellow.png"
import shareQrcodeLogo from "../ui/assets/images/wz.png"
export enum PACKET_MODE {
  random = "拼手气",
  identical = "平分",
}

export enum PRODUCT_TYPE {
  CURRENCY = "currency",
  CONSUME_PROPS = "consume_props",
  NON_CONSUME_PROPS = "non_consume_props",
}

export const QQ_CONNECT_SESSION_TYPE = ["kp_actoken", "kp_accesstoken"]
export const ALL_SESSION_TYPE = ["wc_actoken", "kp_accesstoken", "st_dummy", "kp_actoken", "skey"]
export const GET_DEL_SHARE_PARAM = ["openid", "openkey", "session_id", "session_type", "wxAppid2", "qq_appid"]

// 王者营地相关
export const WZYDINFO = {
  // 打开商城地址
  MALLLINK: "smobagamehelper://hippy?modulename=mall&path=/home",
  OUTERSCENE_MALLLINK: "modulename=mall&path=/home",
  // 分享icon图
  SHAREICON: "https://midas.gtimg.cn/store_config/16600109775063re7viom.png",
  SHAREICON_SQUARE: "https://midas.gtimg.cn/store_config/16600109406680uvoJeCR.png",
  TITLE: "王者荣耀点券红包",
  DESC: "我发了一个王者荣耀点券红包，祝你开黑长胜！",
  CONSUME_PROPS: "点券红包",
}

const info = {
  productType: PRODUCT_TYPE.CURRENCY,
  onlyRandomMode: false,
  maxAmount: 2000,
  rate: 10,
  packetItem: {
    //开发环境
    // productId: "EMPTY_1635929522630671",
    // model_id: "16391043786476",
    // activity_id: "Activity_1639104378_GNPYLA",
    // appid: "1450019044",
    //沙箱环境
    // productId: "EMPTY_1635929522630671",
    // model_id: "16381797199682",
    // activity_id: "Activity_1638179348_GWTJFU",
    // appid: "1450019044",
    //现网环境
    productId: "EMPTY_1635929522630671",
    model_id: "16383521508252",
    activity_id: "Activity_1638352102_GGLQBG",
    appid: "1450019044",
  },
  productName: "王者点券红包",
  productUnit: "点券",
  coverImg: redPacketBg,
  qqCoverImg: "//midas.gtimg.cn/store_config/1652692871968YHShknlq.png",
  greetings: ["祝你开黑把把五杀嘿嘿", "哼哼哈兮快使用双截棍", "test0303"],
  bottomLogo: bottomBg,
  bizTopLogo: topLeftBg,
  recommModel: {
    android: "wzry_partition_all_android",
    iOS: "wzry_partition_all_ios",
  },
  pageTitle: "王者点券红包",
  shareInfo: {
    ICON: "https://midas.gtimg.cn/store_config/1585207867985EI153zif.png",
    MINIPROGRAM_ICON: "https://midas.gtimg.cn/store_config/1608644854868j7OGi4wk_mina.png",
    URL: "https://pay.qq.com/h5/activity/bargain/wzry-post-office.php",
    DESC: "叮叮当～点券红包详情页",
    TITLE: "详情页点券红包",
    SHARE_BIZ_ICON: shareBizIcon,
  },
  shareIndexInfo: {
    ICON: "https://midas.gtimg.cn/store_config/1585207867985EI153zif.png",
    MINIPROGRAM_ICON: "https://midas.gtimg.cn/store_config/1608644854868j7OGi4wk_mina.png",
    URL: "https://pay.qq.com/h5/activity/bargain/wzry-post-office.php",
    DESC: "叮叮当～点券红包首页",
    TITLE: "首页点券红包",
  },
  rules: `
  <p> 1、<span style="color:#DF1B1B">用户身份</span>说明</p>
  <ul>
    <li>
    （1）红包功能中分为发红包和领红包两种身份
    </li>
    <li>
    （2）发红包用户：发红包时可无游戏角色，可抢自己发出的红包
    </li>
    <li>
    （3）领红包用户：先抢红包，后选择分区领取到游戏账户中
</li>
  </ul>


  <p> 2、红包<span style="color:#DF1B1B">限制</span>说明</p>
   <ul>
   <li>
（1）点券红包
      <ol>
            <li>● 单个红包：单个红包总价值不超过¥200 </li>
            <li>● 红包个数：每个红包不可超过100份，每份红包价值需≧¥0.1 </li>
      </ol>
</li>
<li>
（2）皮肤红包（限时）
       <ol>
            <li>● 刘邦-虎啸剑宗秒杀皮肤售卖期间（1月31日~2月6日），支持玩家发放皮肤红包</li>
            <li>● 每个红包中可包进1～50个刘邦-虎啸剑宗皮肤</li>
            <li>● 红包发出后自动生成为平均模式，玩家在每个红包中可以抢到一个皮肤（但支持抢多个红包）</li>
            <li>● 抢到皮肤后发放到游戏邮箱中，请及时领取（注：重复抢到的刘邦-虎啸剑宗皮肤，会化成皮肤碎片*6）</li>
            <li>● 红包中没有被抢完的皮肤，红包有效期结束后会自动返还到发红包玩家的“我的红包记录”中，需要手动领取。领取时会自动转化成与实际支付金额等额的王者荣耀心愿点（1元=10点心愿点）。</li>
</li>
</ol>
</li>

</ul>

  <p> 3、红包<span style="color:#DF1B1B">有效期</span>说明</p>
    <ul>
    <li>

（1）每个红包有效期为24小时，超时没被领取的部分将退还给发红包用户，请及时兑换（注：退还商品为红包内容，非支付金额）


</li>
<li>

（2）红包领取后可在1年内选择抢红包账号下的游戏分区进行兑换（注：当前版本暂不支持跨微信/QQ大区兑换）
</li>
<li>

（3）可在红包记录中查询1年内的发红包/收红包记录
</li>
<li>
（4）点券领取成功后，可登录游戏，在点券充值面板左上角【点券流水】中查看明细
</li>
</ul>

  <p> 3、红包<span style="color:#DF1B1B">模式</span>说明</p>
  <ul>
  <li>

（1）当前红包支持拼手气红包和平分红包两种模式


</li>
<li>
（2）拼手气红包：发红包时选择红包总额和个数，抢红包时每个红包内数量随机生成

</li>
<li>
（3）平分红包：发红包时指定每个红包的金额和个数，抢红包用户领取的红包内容相同

</li>
</ul>


  `,
  maxQuantity: 100,
  minQuantity: 1,
  enableIOS: false,
  recordBg,
  indexLinearColor: {
    start: "#FFFFFF",
    stop: "#F6F6F6",
  },
  detailLinearColor: {
    start: "black",
    stop: "#ff5054",
  },
  // downTime: "2021/12/25 23:59:59", //前端活动失效时间
  // onlineTime: "2021/12/05 23:59:59",
  // offlineTime: "2021/12/15 23:59:59",
  enable: true,
  shareQrcodeLogo: shareQrcodeLogo,
  // "linear-gradient(134deg, #FD963F 0%, #FF5256 100%)",
  mallLink: "https://pay.qq.com/h5/shop.shtml#/order/2/biz/2?pfStructure=common1&serviceZone=1&zoneTabId=1903",
  detailPageSize: 8,
}
const skinInfo = {
  productType: PRODUCT_TYPE.NON_CONSUME_PROPS,
  maxAmount: 200000,
  rate: 10,
  packetItem: {
    appid: "1450019044",
    productId: "EMPTY_1641452367134356",
    //开发环境
    // model_id: "16414551856091",
    // activity_id: "Activity_1641455185_XFPDWA",
    //沙箱环境
    // activity_id: "Activity_1642930002_PMTVYT",
    // model_id: "16429310195580",
    //现网环境
    model_id: "16430949463607",
    activity_id: "Activity_1643094907_EJYBZN",
  },
  productName: "王者皮肤红包",
  productUnit: "点券",
  coverImg: liubangSkinBg,
  greetings: ["祝你开黑把把五杀嘿嘿", "哼哼哈兮快使用双截棍", "test0303"],
  bottomLogo: bottomBg,
  bizTopLogo: topLeftBg,
  recommModel: {
    android: "wzry_partition_all_android",
    iOS: "wzry_partition_all_ios",
  },
  pageTitle: "王者点券红包",
  shareInfo: {
    ICON: "https://midas.gtimg.cn/store_config/1585207867985EI153zif.png",
    MINIPROGRAM_ICON: "https://midas.gtimg.cn/store_config/1608644854868j7OGi4wk_mina.png",
    URL: "https://pay.qq.com/h5/activity/bargain/wzry-post-office.php",
    DESC: "叮叮当～点券红包详情页",
    TITLE: "详情页点券红包",
    SHARE_BIZ_ICON: shareBizIcon,
  },
  shareIndexInfo: {
    ICON: "https://midas.gtimg.cn/store_config/1585207867985EI153zif.png",
    MINIPROGRAM_ICON: "https://midas.gtimg.cn/store_config/1608644854868j7OGi4wk_mina.png",
    URL: "https://pay.qq.com/h5/activity/bargain/wzry-post-office.php",
    DESC: "叮叮当～点券红包首页",
    TITLE: "首页点券红包",
  },
  rules: `
  <p> 1、<span style="color:#DF1B1B">用户身份</span>说明</p>
  <ul>
    <li>
    （1）红包功能中分为发红包和领红包两种身份
    </li>
    <li>
    （2）发红包用户：发红包时可无游戏角色，可抢自己发出的红包
    </li>
    <li>
    （3）领红包用户：先抢红包，后选择分区领取到游戏账户中
</li>
  </ul>


  <p> 2、红包<span style="color:#DF1B1B">限制</span>说明</p>
   <ul>
   <li>

（1）单个红包：单个红包总价值不超过¥200
</li>
<li>
（2）红包个数：每个红包不可超过100份，每份红包价值需≧¥0.1
</li>

</ul>

  <p> 3、红包<span style="color:#DF1B1B">有效期</span>说明</p>
    <ul>
    <li>

（1）每个红包有效期为24小时，超时没被领取的部分将退还给发红包用户，请及时兑换（注：退还商品为红包内容，非支付金额）


</li>
<li>

（2）红包领取后可在1年内选择抢红包账号下的游戏分区进行兑换（注：当前版本暂不支持跨微信/QQ大区兑换）
</li>
<li>

（3）可在红包记录中查询1年内的发红包/收红包记录
</li>
<li>
（4）点券领取成功后，可登录游戏，在点券充值面板左上角【点券流水】中查看明细
</li>
</ul>

  <p> 3、红包<span style="color:#DF1B1B">模式</span>说明</p>
  <ul>
  <li>

（1）当前红包支持拼手气红包和平分红包两种模式


</li>
<li>
（2）拼手气红包：发红包时选择红包总额和个数，抢红包时每个红包内数量随机生成

</li>
<li>
（3）平分红包：发红包时指定每个红包的金额和个数，抢红包用户领取的红包内容相同

</li>
</ul>


  `,
  maxQuantity: 100,
  enableIOS: false,
  recordBg,
  indexLinearColor: {
    start: "#FFFFFF",
    stop: "#F6F6F6",
  },
  detailLinearColor: {
    start: "black",
    stop: "#FF5256",
  },
  // downTime: "2021/12/25 23:59:59", //前端活动失效时间
  // onlineTime: "2021/12/05 23:59:59",
  // offlineTime: "2021/12/15 23:59:59",
  enable: true,
  shareQrcodeLogo: shareQrcodeLogo,
  // "linear-gradient(134deg, #FD963F 0%, #FF5256 100%)",
  mallLink: "https://pay.qq.com/h5/shop.shtml#/order/2/biz/2?pfStructure=common1&serviceZone=1&zoneTabId=1903",
  detailPageSize: 8,
  propsConfig: {
    url: "//pay.qq.com/h5/active/static_data/wzry/wzry_props_config_map.json",
    md5key: "SH2019080715651597125986",
    cachekey: "midas_wechat_store_config_store_vmallConfig_2_2",
  },
}
export default (window as any)?.__midasStaticConfig_red_packet || info
export type configType = typeof skinInfo & typeof info
